var mt = Object.defineProperty;
var Ot = (e, t, n) => t in e ? mt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var p = (e, t, n) => (Ot(e, typeof t != "symbol" ? t + "" : t, n), n);
const Be = "2.17.4";
let Me = !1;
function ye(e) {
  Me = e;
}
const X = (e) => (...t) => {
  Me && console[e](...t);
}, y = {
  error: X("error"),
  warn: X("warn"),
  log: X("log")
}, St = /* @__PURE__ */ new Set([
  "Symbol",
  "Text",
  "Integer",
  "Number",
  "Boolean",
  "Date",
  "Location",
  "Object"
]);
function ue({
  dataFromPreviewApp: e,
  updateFromEntryEditor: t,
  name: n
}) {
  var i;
  e[n] = ((i = t.fields) == null ? void 0 : i[n]) ?? null;
}
function Ue(e) {
  var t;
  return !!(St.has(e.type) || e.type === "Array" && ((t = e.items) == null ? void 0 : t.type) === "Symbol");
}
const H = 10, Dt = "live-preview-editor", gt = "live-preview-sdk";
function S(e, t, n) {
  const i = {
    ...t,
    method: e,
    from: "live-preview",
    source: gt,
    location: window.location.href,
    version: Be
  };
  y.log("Send message", i), n.forEach((s) => {
    var r;
    (r = window.top) == null || r.postMessage(i, s);
  });
}
function Wn(e, t = 100) {
  let n;
  return (...i) => {
    clearTimeout(n), n = setTimeout(() => {
      e.apply(this, i);
    }, t);
  };
}
class At {
  constructor(t, n) {
    p(this, "storageKey");
    p(this, "value");
    this.storageKey = t, this.value = this.restoreSessionData() || n;
  }
  getKey(t, n) {
    return `${t}-${n}`;
  }
  restoreSessionData() {
    try {
      const t = window.sessionStorage.getItem(this.storageKey), n = t ? JSON.parse(t) : null;
      return Array.isArray(n) ? new Map(n) : null;
    } catch {
      return null;
    }
  }
  get(t, n) {
    return this.value.get(this.getKey(t, n));
  }
  set(t, n, i) {
    this.value.set(this.getKey(t, n), i);
    try {
      window.sessionStorage.setItem(
        this.storageKey,
        JSON.stringify(Array.from(this.value.entries()))
      );
    } catch {
      y.warn(`StorageMap: Failed to set data for key "${t}" in sessionStorage`);
    }
  }
  clear() {
    this.value.clear();
    try {
      window.sessionStorage.removeItem(this.storageKey);
    } catch {
      y.warn("StorageMap: Failed to clear data from sessionStorage");
    }
  }
}
function Lt(e) {
  if (!e)
    return e;
  try {
    const t = new URL(e, "https://images.ctfassets.net");
    return t.protocol = "https:", t.href;
  } catch (t) {
    return y.error(`Recevied invalid asset url "${e}"`, t), e;
  }
}
function de(e) {
  if (typeof structuredClone == "function")
    return structuredClone(e);
  try {
    return JSON.parse(JSON.stringify(e));
  } catch (t) {
    return y.warn("Failed to clone data, updates are done on the original one", e, t), e;
  }
}
function Ct() {
  var e;
  try {
    return ((e = window.top) == null ? void 0 : e.location.href) !== window.location.href;
  } catch {
    return !0;
  }
}
function bt() {
  return `${performance.now()}-${Math.random().toString(36).slice(2)}`;
}
function vt(e, t = 500) {
  let n = window.location.href;
  const s = setInterval(() => {
    const r = window.location.href;
    r !== n && (n = r, e(r));
  }, t);
  return () => clearInterval(s);
}
function Fe(e, t) {
  if (!t.length)
    return e;
  try {
    const [n, ...i] = t;
    return Fe(e[n], i);
  } catch {
    return;
  }
}
function Z(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
class Rt {
  get entities() {
    return [
      ...this.entryMap.values(),
      ...this.assetMap.values()
    ];
  }
  updateEntity(t) {
    this.addEntity(t);
  }
  getValue(t, n) {
    t.sys.type;
    const i = this.getEntity(t.sys.linkType, t.sys.id);
    if (!i) {
      console.warn(`Unresolved entity reference: ${t}`);
      return;
    }
    return Fe(i, n);
  }
  getEntitiesFromMap(t, n) {
    const i = [], s = [];
    for (const r of n) {
      const a = this.getEntity(t, r);
      a ? i.push(a) : s.push(r);
    }
    return {
      resolved: i,
      missing: s
    };
  }
  addEntity(t) {
    this.isAsset(t) ? this.assetMap.set(t.sys.id, t) : this.entryMap.set(t.sys.id, t);
  }
  async fetchAsset(t) {
    const { resolved: n, missing: i } = this.getEntitiesFromMap("Asset", [
      t
    ]);
    if (i.length) {
      console.warn(`Asset "${t}" is not in the store`);
      return;
    }
    return n[0];
  }
  async fetchAssets(t) {
    const { resolved: n, missing: i } = this.getEntitiesFromMap("Asset", t);
    if (i.length)
      throw new Error(`Missing assets in the store (${i.join(",")})`);
    return n;
  }
  async fetchEntry(t) {
    const { resolved: n, missing: i } = this.getEntitiesFromMap("Entry", [
      t
    ]);
    if (i.length) {
      console.warn(`Entry "${t}" is not in the store`);
      return;
    }
    return n[0];
  }
  async fetchEntries(t) {
    const { resolved: n, missing: i } = this.getEntitiesFromMap("Entry", t);
    if (i.length)
      throw new Error(`Missing assets in the store (${i.join(",")})`);
    return n;
  }
  isAsset(t) {
    return t.sys.type === "Asset";
  }
  getEntity(t, n) {
    return t === "Asset" ? this.assetMap.get(n) : this.entryMap.get(n);
  }
  constructor({ entities: t, locale: n }) {
    Z(this, "locale", void 0), Z(this, "entryMap", /* @__PURE__ */ new Map()), Z(this, "assetMap", /* @__PURE__ */ new Map()), this.locale = n;
    for (const i of t)
      this.addEntity(i);
  }
}
function M(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var Ie;
(function(e) {
  e.REQUEST_ENTITIES = "REQUEST_ENTITIES", e.REQUESTED_ENTITIES = "REQUESTED_ENTITIES";
})(Ie || (Ie = {}));
class xt extends Rt {
  cleanupPromise(t) {
    setTimeout(() => {
      this.requestCache.delete(t);
    }, 300);
  }
  getCacheId(t) {
    return t.length === 1 ? t[0] : t.join(this.cacheIdSeperator);
  }
  async fetchEntity(t, n) {
    const { missing: i, resolved: s } = this.getEntitiesFromMap(t, n);
    if (i.length === 0)
      return s;
    const r = this.getCacheId(i), a = this.requestCache.get(r);
    if (a)
      return a;
    const o = new Promise((d, u) => {
      const h = this.subscribe("REQUESTED_ENTITIES", (m) => {
        i.every((T) => m.entities.find((g) => g.sys.id === T)) && (clearTimeout(E), d(m.entities), this.cleanupPromise(r), n.forEach((T) => this.cleanupPromise(T)), h());
      }), E = setTimeout(() => {
        u(new Error("Request for entities timed out")), h();
      }, this.timeoutDuration);
      this.sendMessage("REQUEST_ENTITIES", {
        entityIds: i,
        entityType: t,
        locale: this.locale
      });
    });
    return this.requestCache.set(r, o), n.forEach((d) => {
      this.requestCache.set(d, o);
    }), (await o).forEach((d) => {
      this.addEntity(d);
    }), this.getEntitiesFromMap(t, n).resolved;
  }
  async fetchAsset(t) {
    try {
      return (await this.fetchAssets([
        t
      ]))[0];
    } catch {
      console.warn(`Failed to request asset ${t}`);
      return;
    }
  }
  fetchAssets(t) {
    return this.fetchEntity("Asset", t);
  }
  async fetchEntry(t) {
    try {
      return (await this.fetchEntries([
        t
      ]))[0];
    } catch (n) {
      console.warn(`Failed to request entry ${t}`, n);
      return;
    }
  }
  fetchEntries(t) {
    return this.fetchEntity("Entry", t);
  }
  constructor({ entities: t, locale: n, sendMessage: i, subscribe: s, timeoutDuration: r = 3e3 }) {
    super({
      entities: t,
      locale: n
    }), M(this, "requestCache", /* @__PURE__ */ new Map()), M(this, "sendMessage", void 0), M(this, "subscribe", void 0), M(this, "timeoutDuration", void 0), M(this, "cacheIdSeperator", ","), this.sendMessage = i, this.subscribe = s, this.timeoutDuration = r;
  }
}
const ie = "Collection";
function $(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function he(e) {
  return `${e}${ie}`;
}
function kt(e) {
  if (e.endsWith(ie))
    return $(e.replace(ie, ""));
}
const P = "Asset";
function K(e) {
  return !!(e && typeof e == "object" && "sys" in e && e.sys.id);
}
const ee = {};
function _e(e, t) {
  return ee[e] || (ee[e] = new xt({
    entities: [],
    sendMessage: t,
    subscribe: (n, i) => {
      const s = (r) => {
        typeof r.data != "object" || !r.data || r.data.from === "live-preview" && r.data.method === n && i(r.data);
      };
      return window.addEventListener("message", s), () => window.removeEventListener("message", s);
    },
    locale: e
  })), ee[e];
}
async function fe({
  entityReferenceMap: e,
  referenceId: t,
  isAsset: n,
  locale: i,
  sendMessage: s
}) {
  var o, l, d;
  const r = e.get(t);
  if (r)
    return {
      reference: r,
      typeName: "contentType" in r.sys && ((d = (l = (o = r.sys) == null ? void 0 : o.contentType) == null ? void 0 : l.sys) != null && d.id) ? $(r.sys.contentType.sys.id) : P
    };
  if (n) {
    const u = await _e(i, s).fetchAsset(t);
    if (!u)
      throw new Error(`Unknown reference ${t}`);
    return {
      reference: u,
      typeName: P
    };
  }
  const a = await _e(i, s).fetchEntry(t);
  if (!a)
    throw new Error(`Unknown reference ${t}`);
  return {
    reference: a,
    typeName: $(a.sys.contentType.sys.id)
  };
}
function wt(e) {
  return typeof e.data != "object" || !e.data ? !1 : "from" in e.data && e.data.from === "live-preview" || "source" in e.data && e.data.source === Dt;
}
var N = /* @__PURE__ */ ((e) => (e.FIELD_ID = "data-contentful-field-id", e.ENTRY_ID = "data-contentful-entry-id", e.ASSET_ID = "data-contentful-asset-id", e.LOCALE = "data-contentful-locale", e))(N || {}), C = /* @__PURE__ */ ((e) => (e.MOUSE_MOVE = "MOUSE_MOVE", e.SCROLL_START = "SCROLL_START", e.SCROLL_END = "SCROLL_END", e.RESIZE_START = "RESIZE_START", e.RESIZE_END = "RESIZE_END", e.TAGGED_ELEMENTS = "TAGGED_ELEMENTS", e.INSPECTOR_MODE_CHANGED = "INSPECTOR_MODE_CHANGED", e))(C || {}), Pe = { 0: 8203, 1: 8204, 2: 8205, 3: 8290, 4: 8291, 5: 8288, 6: 65279, 7: 8289, 8: 119155, 9: 119156, a: 119157, b: 119158, c: 119159, d: 119160, e: 119161, f: 119162 }, Ge = { 0: 8203, 1: 8204, 2: 8205, 3: 65279 }, Bt = new Array(4).fill(String.fromCodePoint(Ge[0])).join(""), me = "\0", Mt = Object.fromEntries(Object.entries(Ge).map((e) => e.reverse())), Oe = Object.fromEntries(Object.entries(Pe).map((e) => e.reverse())), Ut = `${Object.values(Pe).map((e) => `\\u{${e.toString(16)}}`).join("")}`, Ft = new RegExp(`[${Ut}]{4,}`, "gu");
function Pt(e) {
  let t = e.match(Ft);
  if (t)
    return Gt(t[0], !0)[0];
}
function Gt(e, t = !1) {
  let n = Array.from(e);
  if (n.length % 2 === 0) {
    if (n.length % 4 || !e.startsWith(Bt))
      return Vt(n, t);
  } else
    throw new Error("Encoded data has invalid length");
  let i = [];
  for (let s = n.length * 0.25; s--; ) {
    let r = n.slice(s * 4, s * 4 + 4).map((a) => Mt[a.codePointAt(0)]).join("");
    i.unshift(String.fromCharCode(parseInt(r, 4)));
  }
  if (t) {
    i.shift();
    let s = i.indexOf(me);
    return s === -1 && (s = i.length), [JSON.parse(i.slice(0, s).join(""))];
  }
  return i.join("").split(me).filter(Boolean).map((s) => JSON.parse(s));
}
function Vt(e, t) {
  var n;
  let i = [];
  for (let o = e.length * 0.5; o--; ) {
    let l = `${Oe[e[o * 2].codePointAt(0)]}${Oe[e[o * 2 + 1].codePointAt(0)]}`;
    i.unshift(String.fromCharCode(parseInt(l, 16)));
  }
  let s = [], r = [i.join("")], a = 10;
  for (; r.length; ) {
    let o = r.shift();
    try {
      if (s.push(JSON.parse(o)), t)
        return s;
    } catch (l) {
      if (!a--)
        throw l;
      let d = +((n = l.message.match(/\sposition\s(\d+)$/)) == null ? void 0 : n[1]);
      if (!d)
        throw l;
      r.unshift(o.substring(0, d), o.substring(d));
    }
  }
  return s;
}
function Se(e) {
  return Pt(e);
}
const se = (e) => {
  if (!e || e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  const t = e;
  return !(!t.hasAttribute(N.FIELD_ID) || !t.hasAttribute(N.ENTRY_ID) && !t.hasAttribute(N.ASSET_ID));
};
function Kt(e, t) {
  if (!se(e))
    return null;
  const n = e.getAttribute(N.FIELD_ID), i = e.getAttribute(N.LOCALE) ?? t, s = e.getAttribute(N.ENTRY_ID), r = e.getAttribute(N.ASSET_ID);
  return s ? { entryId: s, fieldId: n, locale: i } : r ? { assetId: r, fieldId: n, locale: i } : null;
}
function re(e = window.document, t) {
  const n = document.createTreeWalker(e, NodeFilter.SHOW_ALL, (s) => {
    if (s.nodeType === Node.TEXT_NODE) {
      const r = s.textContent ?? "", a = Se(r);
      return (a == null ? void 0 : a.origin) !== "contentful.com" ? NodeFilter.FILTER_SKIP : se(s.parentElement) ? t ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    }
    return t ? NodeFilter.FILTER_SKIP : se(s) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
  }), i = [];
  for (; n.nextNode(); ) {
    const s = n.currentNode;
    if (s.nodeType === Node.ELEMENT_NODE) {
      i.push(n.currentNode);
      continue;
    }
    if (!s.textContent)
      continue;
    const r = Se(s.textContent);
    if (!(r != null && r.contentful))
      continue;
    const { contentful: a } = r, o = s.parentElement;
    o && (a.entityType === "Entry" ? o.setAttribute(N.ENTRY_ID, a.entity) : o.setAttribute(N.ASSET_ID, a.entity), o.setAttribute(N.LOCALE, a.locale), o.setAttribute(N.FIELD_ID, a.field), i.push(o));
  }
  return i;
}
function Ve() {
  return [
    ...new Set(
      re().map((e) => e.getAttribute(N.ENTRY_ID)).filter(Boolean)
    )
  ];
}
class jt {
  constructor(t) {
    p(this, "isScrolling", !1);
    p(this, "scrollTimeout");
    p(this, "isResizing", !1);
    p(this, "resizeTimeout");
    p(this, "hoveredElement");
    p(this, "taggedElements", []);
    p(this, "taggedElementMutationObserver");
    // Handles incoming messages from Contentful
    p(this, "receiveMessage", (t) => {
      if (t.method === C.INSPECTOR_MODE_CHANGED) {
        const { isInspectorActive: n } = t;
        n && this.sendAllElements();
      }
    });
    /** Checks if the hovered element is an tagged entry and then sends it to the editor */
    p(this, "addHoverListener", () => {
      const t = (n) => {
        const i = n.composedPath();
        for (const s of i) {
          const r = s;
          if (r.nodeName === "BODY")
            break;
          if (typeof (r == null ? void 0 : r.getAttribute) == "function" && this.handleTaggedElement(r))
            return;
        }
        this.hoveredElement && (this.hoveredElement = void 0, S(
          C.MOUSE_MOVE,
          { element: null },
          this.options.targetOrigin
        ));
      };
      return window.addEventListener("mouseover", t), () => window.removeEventListener("mouseover", t);
    });
    /** Sends scroll start and end event to the editor, on end it also sends the tagged elements again */
    p(this, "addScrollListener", () => {
      const { targetOrigin: t } = this.options, n = () => {
        this.isScrolling || (this.isScrolling = !0, S(C.SCROLL_START, {}, t)), this.scrollTimeout && clearTimeout(this.scrollTimeout), this.scrollTimeout = setTimeout(() => {
          this.isScrolling = !1, S(C.SCROLL_END, {}, t), this.sendAllElements(), this.hoveredElement && this.handleTaggedElement(this.hoveredElement);
        }, 150);
      };
      return window.addEventListener("scroll", n), () => window.removeEventListener("scroll", n);
    });
    /** Detects DOM changes and sends the tagged elements to the editor */
    p(this, "addMutationListener", () => {
      const t = new MutationObserver(() => {
        var i;
        const n = re();
        ((i = this.taggedElements) == null ? void 0 : i.length) !== n.length && this.sendAllElements();
      });
      return t.observe(document.body, {
        attributes: !0,
        attributeFilter: [
          N.ENTRY_ID,
          N.FIELD_ID,
          N.LOCALE
        ],
        childList: !0,
        subtree: !0
      }), () => t.disconnect();
    });
    /** Sends resize start and end event to the editor, on end it also sends the tagged elements again */
    p(this, "addResizeListener", () => {
      const { targetOrigin: t } = this.options, n = new ResizeObserver(() => {
        this.isResizing || (this.isResizing = !0, S(C.RESIZE_START, {}, t)), this.resizeTimeout && clearTimeout(this.resizeTimeout), this.resizeTimeout = setTimeout(() => {
          this.isResizing = !1, S(C.RESIZE_END, {}, t), this.sendAllElements(), this.hoveredElement && this.handleTaggedElement(this.hoveredElement);
        }, 150);
      });
      return n.observe(document.body), () => n.disconnect();
    });
    /**
     * Validates if the element has the inspector mode attributes
     * and sends it then to the editor
     */
    p(this, "handleTaggedElement", (t) => {
      const { targetOrigin: n, locale: i } = this.options, s = Kt(t, i);
      return s ? (this.hoveredElement = t, S(
        C.MOUSE_MOVE,
        {
          element: {
            attributes: s,
            coordinates: t.getBoundingClientRect()
          }
        },
        n
      ), !0) : !1;
    });
    /**
     * Finds all elements that have all inspector mode attributes
     * and sends them to the editor
     */
    p(this, "sendAllElements", () => {
      const { targetOrigin: t } = this.options, n = re();
      this.taggedElements = n, this.taggedElementMutationObserver && this.taggedElementMutationObserver.disconnect();
      const i = () => {
        S(
          C.TAGGED_ELEMENTS,
          {
            elements: n.map((s) => ({
              coordinates: s.getBoundingClientRect()
            }))
          },
          t
        );
      };
      this.taggedElementMutationObserver = new MutationObserver(i), this.taggedElements.forEach((s) => {
        var r;
        (r = this.taggedElementMutationObserver) == null || r.observe(s, {
          attributes: !0,
          attributeFilter: [
            N.ENTRY_ID,
            N.FIELD_ID,
            N.LOCALE
          ],
          childList: !0,
          subtree: !0,
          characterData: !0
        });
      }), i();
    });
    this.options = t, this.addHoverListener(), this.addScrollListener(), this.addMutationListener(), this.addResizeListener();
  }
}
var L = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Xn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var D = {}, R = {};
Object.defineProperty(R, "__esModule", { value: !0 });
R.BLOCKS = void 0;
var De;
(function(e) {
  e.DOCUMENT = "document", e.PARAGRAPH = "paragraph", e.HEADING_1 = "heading-1", e.HEADING_2 = "heading-2", e.HEADING_3 = "heading-3", e.HEADING_4 = "heading-4", e.HEADING_5 = "heading-5", e.HEADING_6 = "heading-6", e.OL_LIST = "ordered-list", e.UL_LIST = "unordered-list", e.LIST_ITEM = "list-item", e.HR = "hr", e.QUOTE = "blockquote", e.EMBEDDED_ENTRY = "embedded-entry-block", e.EMBEDDED_ASSET = "embedded-asset-block", e.EMBEDDED_RESOURCE = "embedded-resource-block", e.TABLE = "table", e.TABLE_ROW = "table-row", e.TABLE_CELL = "table-cell", e.TABLE_HEADER_CELL = "table-header-cell";
})(De || (R.BLOCKS = De = {}));
var w = {};
Object.defineProperty(w, "__esModule", { value: !0 });
w.INLINES = void 0;
var ge;
(function(e) {
  e.HYPERLINK = "hyperlink", e.ENTRY_HYPERLINK = "entry-hyperlink", e.ASSET_HYPERLINK = "asset-hyperlink", e.RESOURCE_HYPERLINK = "resource-hyperlink", e.EMBEDDED_ENTRY = "embedded-entry-inline", e.EMBEDDED_RESOURCE = "embedded-resource-inline";
})(ge || (w.INLINES = ge = {}));
var V = {};
Object.defineProperty(V, "__esModule", { value: !0 });
V.MARKS = void 0;
var Ae;
(function(e) {
  e.BOLD = "bold", e.ITALIC = "italic", e.UNDERLINE = "underline", e.CODE = "code", e.SUPERSCRIPT = "superscript", e.SUBSCRIPT = "subscript";
})(Ae || (V.MARKS = Ae = {}));
var Ke = {};
(function(e) {
  var t = L && L.__spreadArray || function(a, o, l) {
    if (l || arguments.length === 2)
      for (var d = 0, u = o.length, h; d < u; d++)
        (h || !(d in o)) && (h || (h = Array.prototype.slice.call(o, 0, d)), h[d] = o[d]);
    return a.concat(h || Array.prototype.slice.call(o));
  }, n;
  Object.defineProperty(e, "__esModule", { value: !0 }), e.V1_MARKS = e.V1_NODE_TYPES = e.TEXT_CONTAINERS = e.HEADINGS = e.CONTAINERS = e.VOID_BLOCKS = e.TABLE_BLOCKS = e.LIST_ITEM_BLOCKS = e.TOP_LEVEL_BLOCKS = void 0;
  var i = R, s = w, r = V;
  e.TOP_LEVEL_BLOCKS = [
    i.BLOCKS.PARAGRAPH,
    i.BLOCKS.HEADING_1,
    i.BLOCKS.HEADING_2,
    i.BLOCKS.HEADING_3,
    i.BLOCKS.HEADING_4,
    i.BLOCKS.HEADING_5,
    i.BLOCKS.HEADING_6,
    i.BLOCKS.OL_LIST,
    i.BLOCKS.UL_LIST,
    i.BLOCKS.HR,
    i.BLOCKS.QUOTE,
    i.BLOCKS.EMBEDDED_ENTRY,
    i.BLOCKS.EMBEDDED_ASSET,
    i.BLOCKS.EMBEDDED_RESOURCE,
    i.BLOCKS.TABLE
  ], e.LIST_ITEM_BLOCKS = [
    i.BLOCKS.PARAGRAPH,
    i.BLOCKS.HEADING_1,
    i.BLOCKS.HEADING_2,
    i.BLOCKS.HEADING_3,
    i.BLOCKS.HEADING_4,
    i.BLOCKS.HEADING_5,
    i.BLOCKS.HEADING_6,
    i.BLOCKS.OL_LIST,
    i.BLOCKS.UL_LIST,
    i.BLOCKS.HR,
    i.BLOCKS.QUOTE,
    i.BLOCKS.EMBEDDED_ENTRY,
    i.BLOCKS.EMBEDDED_ASSET,
    i.BLOCKS.EMBEDDED_RESOURCE
  ], e.TABLE_BLOCKS = [
    i.BLOCKS.TABLE,
    i.BLOCKS.TABLE_ROW,
    i.BLOCKS.TABLE_CELL,
    i.BLOCKS.TABLE_HEADER_CELL
  ], e.VOID_BLOCKS = [
    i.BLOCKS.HR,
    i.BLOCKS.EMBEDDED_ENTRY,
    i.BLOCKS.EMBEDDED_ASSET,
    i.BLOCKS.EMBEDDED_RESOURCE
  ], e.CONTAINERS = (n = {}, n[i.BLOCKS.OL_LIST] = [i.BLOCKS.LIST_ITEM], n[i.BLOCKS.UL_LIST] = [i.BLOCKS.LIST_ITEM], n[i.BLOCKS.LIST_ITEM] = e.LIST_ITEM_BLOCKS, n[i.BLOCKS.QUOTE] = [i.BLOCKS.PARAGRAPH], n[i.BLOCKS.TABLE] = [i.BLOCKS.TABLE_ROW], n[i.BLOCKS.TABLE_ROW] = [i.BLOCKS.TABLE_CELL, i.BLOCKS.TABLE_HEADER_CELL], n[i.BLOCKS.TABLE_CELL] = [i.BLOCKS.PARAGRAPH], n[i.BLOCKS.TABLE_HEADER_CELL] = [i.BLOCKS.PARAGRAPH], n), e.HEADINGS = [
    i.BLOCKS.HEADING_1,
    i.BLOCKS.HEADING_2,
    i.BLOCKS.HEADING_3,
    i.BLOCKS.HEADING_4,
    i.BLOCKS.HEADING_5,
    i.BLOCKS.HEADING_6
  ], e.TEXT_CONTAINERS = t([i.BLOCKS.PARAGRAPH], e.HEADINGS, !0), e.V1_NODE_TYPES = [
    i.BLOCKS.DOCUMENT,
    i.BLOCKS.PARAGRAPH,
    i.BLOCKS.HEADING_1,
    i.BLOCKS.HEADING_2,
    i.BLOCKS.HEADING_3,
    i.BLOCKS.HEADING_4,
    i.BLOCKS.HEADING_5,
    i.BLOCKS.HEADING_6,
    i.BLOCKS.OL_LIST,
    i.BLOCKS.UL_LIST,
    i.BLOCKS.LIST_ITEM,
    i.BLOCKS.HR,
    i.BLOCKS.QUOTE,
    i.BLOCKS.EMBEDDED_ENTRY,
    i.BLOCKS.EMBEDDED_ASSET,
    s.INLINES.HYPERLINK,
    s.INLINES.ENTRY_HYPERLINK,
    s.INLINES.ASSET_HYPERLINK,
    s.INLINES.EMBEDDED_ENTRY,
    "text"
  ], e.V1_MARKS = [r.MARKS.BOLD, r.MARKS.CODE, r.MARKS.ITALIC, r.MARKS.UNDERLINE];
})(Ke);
var je = {};
Object.defineProperty(je, "__esModule", { value: !0 });
var Ye = {};
Object.defineProperty(Ye, "__esModule", { value: !0 });
var J = {};
Object.defineProperty(J, "__esModule", { value: !0 });
J.EMPTY_DOCUMENT = void 0;
var Le = R;
J.EMPTY_DOCUMENT = {
  nodeType: Le.BLOCKS.DOCUMENT,
  data: {},
  content: [
    {
      nodeType: Le.BLOCKS.PARAGRAPH,
      data: {},
      content: [
        {
          nodeType: "text",
          value: "",
          marks: [],
          data: {}
        }
      ]
    }
  ]
};
var b = {};
Object.defineProperty(b, "__esModule", { value: !0 });
b.isText = b.isBlock = b.isInline = void 0;
var Yt = R, Ht = w;
function He(e, t) {
  for (var n = 0, i = Object.keys(e); n < i.length; n++) {
    var s = i[n];
    if (t === e[s])
      return !0;
  }
  return !1;
}
function $t(e) {
  return He(Ht.INLINES, e.nodeType);
}
b.isInline = $t;
function Qt(e) {
  return He(Yt.BLOCKS, e.nodeType);
}
b.isBlock = Qt;
function zt(e) {
  return e.nodeType === "text";
}
b.isText = zt;
(function(e) {
  var t = L && L.__createBinding || (Object.create ? function(u, h, E, m) {
    m === void 0 && (m = E);
    var T = Object.getOwnPropertyDescriptor(h, E);
    (!T || ("get" in T ? !h.__esModule : T.writable || T.configurable)) && (T = { enumerable: !0, get: function() {
      return h[E];
    } }), Object.defineProperty(u, m, T);
  } : function(u, h, E, m) {
    m === void 0 && (m = E), u[m] = h[E];
  }), n = L && L.__setModuleDefault || (Object.create ? function(u, h) {
    Object.defineProperty(u, "default", { enumerable: !0, value: h });
  } : function(u, h) {
    u.default = h;
  }), i = L && L.__exportStar || function(u, h) {
    for (var E in u)
      E !== "default" && !Object.prototype.hasOwnProperty.call(h, E) && t(h, u, E);
  }, s = L && L.__importStar || function(u) {
    if (u && u.__esModule)
      return u;
    var h = {};
    if (u != null)
      for (var E in u)
        E !== "default" && Object.prototype.hasOwnProperty.call(u, E) && t(h, u, E);
    return n(h, u), h;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.helpers = e.EMPTY_DOCUMENT = e.MARKS = e.INLINES = e.BLOCKS = void 0;
  var r = R;
  Object.defineProperty(e, "BLOCKS", { enumerable: !0, get: function() {
    return r.BLOCKS;
  } });
  var a = w;
  Object.defineProperty(e, "INLINES", { enumerable: !0, get: function() {
    return a.INLINES;
  } });
  var o = V;
  Object.defineProperty(e, "MARKS", { enumerable: !0, get: function() {
    return o.MARKS;
  } }), i(Ke, e), i(je, e), i(Ye, e);
  var l = J;
  Object.defineProperty(e, "EMPTY_DOCUMENT", { enumerable: !0, get: function() {
    return l.EMPTY_DOCUMENT;
  } });
  var d = s(b);
  e.helpers = d;
})(D);
function Ce(e) {
  return !e || typeof e != "object" || !("sys" in e) ? !1 : e.sys.type !== "ResourceLink";
}
function be(e) {
  return !e || typeof e != "object" || !("sys" in e) ? !1 : e.sys.type === "ResourceLink";
}
function Ee(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = e;
  return t.content && t.nodeType === D.BLOCKS.DOCUMENT;
}
const $e = [
  D.BLOCKS.EMBEDDED_ENTRY,
  D.BLOCKS.EMBEDDED_ASSET,
  D.INLINES.EMBEDDED_ENTRY,
  D.INLINES.ENTRY_HYPERLINK,
  D.INLINES.ASSET_HYPERLINK
];
function Qe(e) {
  return e.sys && "linkType" in e.sys && e.sys.linkType === P;
}
function Jt(e, t) {
  return e.name.value === "items" && kt(t) || e.name.value;
}
function ze(e, t) {
  var i, s;
  const n = [];
  for (const r of e)
    r.kind === "Field" && (n.push({
      name: r.name.value,
      alias: (i = r.alias) == null ? void 0 : i.value,
      __typename: t
    }), (s = r.selectionSet) != null && s.selections && n.push(
      ...ze(
        r.selectionSet.selections,
        Jt(r, t)
      )
    ));
  return n;
}
function qt(e) {
  var i;
  const t = [];
  for (const s of e.definitions)
    if (s.kind === "OperationDefinition" || s.kind === "FragmentDefinition") {
      const r = "typeCondition" in s ? s.typeCondition.name.value : (i = s.name) == null ? void 0 : i.value;
      if (!r) {
        y.warn("Could not generate __typename for query definition", s);
        continue;
      }
      for (const a of s.selectionSet.selections)
        a.kind === "Field" && t.push(...ze(s.selectionSet.selections, r));
    }
  const n = /* @__PURE__ */ new Map();
  for (const { __typename: s, alias: r, name: a } of t) {
    const o = n.get(s) || {
      alias: /* @__PURE__ */ new Map(),
      fields: /* @__PURE__ */ new Set()
    };
    o.fields.add(a), r && o.alias.set(a, r), n.set(s, o);
  }
  return n;
}
function Je(e, t, n) {
  if (!n)
    return !0;
  const i = n.get(t);
  return i ? i.fields.has(e) || i.fields.has(he(e)) : !1;
}
function pe(e, t, n) {
  var s;
  const i = (s = n == null ? void 0 : n.get(t)) == null ? void 0 : s.alias;
  if (!i)
    return e;
  for (const r in e) {
    const a = i == null ? void 0 : i.get(r);
    a !== r && (e[a] = e[r]);
  }
  return e;
}
function qe(e, t, n) {
  var i, s;
  try {
    const r = t.fields.file, a = r == null ? void 0 : r.details, o = {
      ...e,
      // GraphQL flattens some information
      // and as the live updates are coming from the CMA, we need to transform them
      title: t.fields.title,
      description: t.fields.description,
      contentType: r == null ? void 0 : r.contentType,
      url: Lt(r == null ? void 0 : r.url),
      // Note: video has no `width` and `height`
      width: (i = a == null ? void 0 : a.image) == null ? void 0 : i.width,
      height: (s = a == null ? void 0 : a.image) == null ? void 0 : s.height
    };
    return pe(o, P, n);
  } catch (r) {
    return y.warn("Failed update asset", { dataFromPreviewApp: e, updateFromEntryEditor: t }, r), e;
  }
}
async function Wt({
  contentType: e,
  dataFromPreviewApp: t,
  updateFromEntryEditor: n,
  locale: i,
  entityReferenceMap: s,
  gqlParams: r,
  sendMessage: a
}) {
  var d;
  if (t.sys.id !== n.sys.id)
    return t;
  const o = de(t), l = $(e.sys.id);
  for (const u of e.fields) {
    const h = u.apiName ?? u.name;
    Je(h, l, r) && (Ue(u) ? ue({
      dataFromPreviewApp: o,
      updateFromEntryEditor: n,
      name: h
    }) : u.type === "RichText" ? await Xt({
      dataFromPreviewApp: o,
      updateFromEntryEditor: n,
      entityReferenceMap: s,
      name: h,
      locale: i,
      gqlParams: r,
      sendMessage: a
    }) : u.type === "Link" ? await nt({
      dataFromPreviewApp: o,
      updateFromEntryEditor: n,
      name: h,
      locale: i,
      entityReferenceMap: s,
      gqlParams: r,
      sendMessage: a
    }) : u.type === "Array" && ((d = u.items) == null ? void 0 : d.type) === "Link" && await it({
      dataFromPreviewApp: o,
      updateFromEntryEditor: n,
      name: h,
      locale: i,
      entityReferenceMap: s,
      gqlParams: r,
      sendMessage: a
    }));
  }
  return pe(o, l, r);
}
function ve(e) {
  return Object.values(e).every((t) => t.length === 0);
}
async function We(e, t, n, i, s, r, a) {
  if ($e.includes(e.nodeType)) {
    if (e.data && e.data.target && e.data.target.sys) {
      const o = {
        sys: { ...e.data.target.sys, type: "Link", linkType: e.data.target.sys.type }
      };
      let l;
      if (e.data.target.sys.linkType === "Entry" ? l = await et({
        referenceFromPreviewApp: null,
        updatedReference: o,
        entityReferenceMap: i,
        locale: s,
        gqlParams: a,
        sendMessage: r
      }) : e.data.target.sys.linkType === "Asset" && (l = await Ze({
        referenceFromPreviewApp: null,
        updatedReference: o,
        entityReferenceMap: i,
        locale: s,
        gqlParams: a,
        sendMessage: r
      })), l)
        switch (e.nodeType) {
          case D.BLOCKS.EMBEDDED_ENTRY:
            t.block.push(l);
            break;
          case D.BLOCKS.EMBEDDED_ASSET:
            n.block.push(l);
            break;
          case D.INLINES.EMBEDDED_ENTRY:
            t.inline.push(l);
            break;
          case D.INLINES.ENTRY_HYPERLINK:
            t.hyperlink.push(l);
            break;
          case D.INLINES.ASSET_HYPERLINK:
            n.hyperlink.push(l);
            break;
          default:
            y.warn("Unhandled nodeType in embedded entries in rich text", {
              nodeType: e.nodeType,
              ref: l
            });
        }
    }
  } else if (e.content)
    for (const o of e.content)
      await We(
        o,
        t,
        n,
        i,
        s,
        r,
        a
      );
}
async function Xe(e, t, n, i, s) {
  const r = { block: [], inline: [], hyperlink: [] }, a = { block: [], inline: [], hyperlink: [] };
  if (e)
    for (const o of e.content)
      await We(o, r, a, t, n, i, s);
  return {
    entries: ve(r) ? { block: [], inline: [], hyperlink: [] } : r,
    assets: ve(a) ? { block: [], inline: [], hyperlink: [] } : a
  };
}
async function Xt({
  dataFromPreviewApp: e,
  updateFromEntryEditor: t,
  name: n,
  locale: i,
  entityReferenceMap: s,
  gqlParams: r,
  sendMessage: a
}) {
  var o;
  e[n] || (e[n] = {}), e[n].json = ((o = t == null ? void 0 : t.fields) == null ? void 0 : o[n]) || null, e[n].links = await Xe(
    e[n].json,
    s,
    i,
    a,
    r
  );
}
async function Ze({
  referenceFromPreviewApp: e,
  updatedReference: t,
  entityReferenceMap: n,
  locale: i,
  gqlParams: s,
  sendMessage: r
}) {
  const { reference: a } = await fe({
    entityReferenceMap: n,
    referenceId: t.sys.id,
    isAsset: !0,
    locale: i,
    sendMessage: r
  });
  return qe(
    {
      ...e,
      ...t,
      __typename: P
    },
    a,
    s
  );
}
async function et({
  referenceFromPreviewApp: e,
  updatedReference: t,
  entityReferenceMap: n,
  locale: i,
  gqlParams: s,
  sendMessage: r
}) {
  var d;
  const { reference: a, typeName: o } = await fe({
    entityReferenceMap: n,
    referenceId: t.sys.id,
    locale: i,
    sendMessage: r
  }), l = {
    ...e,
    ...t,
    __typename: o
  };
  for (const u in a.fields) {
    if (!Je(u, o, s))
      continue;
    const h = a.fields[u];
    if (h && typeof h == "object")
      Ee(h) && (l[u] = { json: h }, l[u].links = await Xe(
        h,
        n,
        i,
        r,
        s
      )), "sys" in h && (l[u] = h, await nt({
        dataFromPreviewApp: l,
        updateFromEntryEditor: a,
        locale: i,
        entityReferenceMap: n,
        name: u,
        gqlParams: s,
        sendMessage: r
      }));
    else if (Array.isArray(h) && ((d = h[0]) != null && d.sys)) {
      const E = he(u);
      l[E] = { items: h }, await it({
        dataFromPreviewApp: l,
        updateFromEntryEditor: a,
        locale: i,
        entityReferenceMap: n,
        name: u,
        gqlParams: s,
        sendMessage: r
      });
    } else
      l[u] = h;
  }
  return pe(l, o, s);
}
async function tt({
  referenceFromPreviewApp: e,
  updatedReference: t,
  entityReferenceMap: n,
  locale: i,
  gqlParams: s,
  sendMessage: r
}) {
  return t ? e && e.__typename ? e : t.__typename ? t : Qe(t) ? Ze({
    referenceFromPreviewApp: e,
    updatedReference: t,
    entityReferenceMap: n,
    locale: i,
    gqlParams: s,
    sendMessage: r
  }) : et({
    referenceFromPreviewApp: e,
    updatedReference: t,
    entityReferenceMap: n,
    locale: i,
    gqlParams: s,
    sendMessage: r
  }) : null;
}
async function nt({
  dataFromPreviewApp: e,
  updateFromEntryEditor: t,
  name: n,
  locale: i,
  entityReferenceMap: s,
  gqlParams: r,
  sendMessage: a
}) {
  var l;
  const o = (l = t == null ? void 0 : t.fields) == null ? void 0 : l[n];
  e[n] = await tt({
    referenceFromPreviewApp: e[n],
    updatedReference: o,
    entityReferenceMap: s,
    locale: i,
    gqlParams: r,
    sendMessage: a
  });
}
async function it({
  dataFromPreviewApp: e,
  updateFromEntryEditor: t,
  name: n,
  locale: i,
  entityReferenceMap: s,
  gqlParams: r,
  sendMessage: a
}) {
  var u;
  const o = he(n), l = ((u = t == null ? void 0 : t.fields) == null ? void 0 : u[n]) || [], d = await Promise.all(
    l.map(async (h) => {
      var T, g;
      const E = (g = (T = e[o]) == null ? void 0 : T.items) == null ? void 0 : g.find((_t) => _t.sys.id === h.sys.id);
      return await tt({
        referenceFromPreviewApp: E,
        updatedReference: h,
        entityReferenceMap: s,
        locale: i,
        gqlParams: r,
        sendMessage: a
      });
    })
  );
  e[o] || (e[o] = { items: [] }), e[o].items = d.filter(Boolean);
}
var Q = function() {
  return Q = Object.assign || function(t) {
    for (var n, i = 1, s = arguments.length; i < s; i++) {
      n = arguments[i];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Q.apply(this, arguments);
};
function te(e, t) {
  if (!!!e)
    throw new Error(t);
}
function Zt(e) {
  return typeof e == "object" && e !== null;
}
function en(e, t) {
  if (!!!e)
    throw new Error(
      t ?? "Unexpected invariant triggered."
    );
}
const tn = /\r\n|[\n\r]/g;
function ae(e, t) {
  let n = 0, i = 1;
  for (const s of e.body.matchAll(tn)) {
    if (typeof s.index == "number" || en(!1), s.index >= t)
      break;
    n = s.index + s[0].length, i += 1;
  }
  return {
    line: i,
    column: t + 1 - n
  };
}
function nn(e) {
  return st(
    e.source,
    ae(e.source, e.start)
  );
}
function st(e, t) {
  const n = e.locationOffset.column - 1, i = "".padStart(n) + e.body, s = t.line - 1, r = e.locationOffset.line - 1, a = t.line + r, o = t.line === 1 ? n : 0, l = t.column + o, d = `${e.name}:${a}:${l}
`, u = i.split(/\r\n|[\n\r]/g), h = u[s];
  if (h.length > 120) {
    const E = Math.floor(l / 80), m = l % 80, T = [];
    for (let g = 0; g < h.length; g += 80)
      T.push(h.slice(g, g + 80));
    return d + Re([
      [`${a} |`, T[0]],
      ...T.slice(1, E + 1).map((g) => ["|", g]),
      ["|", "^".padStart(m)],
      ["|", T[E + 1]]
    ]);
  }
  return d + Re([
    // Lines specified like this: ["prefix", "string"],
    [`${a - 1} |`, u[s - 1]],
    [`${a} |`, h],
    ["|", "^".padStart(l)],
    [`${a + 1} |`, u[s + 1]]
  ]);
}
function Re(e) {
  const t = e.filter(([i, s]) => s !== void 0), n = Math.max(...t.map(([i]) => i.length));
  return t.map(([i, s]) => i.padStart(n) + (s ? " " + s : "")).join(`
`);
}
function sn(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
class Te extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...n) {
    var i, s, r;
    const { nodes: a, source: o, positions: l, path: d, originalError: u, extensions: h } = sn(n);
    super(t), this.name = "GraphQLError", this.path = d ?? void 0, this.originalError = u ?? void 0, this.nodes = xe(
      Array.isArray(a) ? a : a ? [a] : void 0
    );
    const E = xe(
      (i = this.nodes) === null || i === void 0 ? void 0 : i.map((T) => T.loc).filter((T) => T != null)
    );
    this.source = o ?? (E == null || (s = E[0]) === null || s === void 0 ? void 0 : s.source), this.positions = l ?? (E == null ? void 0 : E.map((T) => T.start)), this.locations = l && o ? l.map((T) => ae(o, T)) : E == null ? void 0 : E.map((T) => ae(T.source, T.start));
    const m = Zt(
      u == null ? void 0 : u.extensions
    ) ? u == null ? void 0 : u.extensions : void 0;
    this.extensions = (r = h ?? m) !== null && r !== void 0 ? r : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), u != null && u.stack ? Object.defineProperty(this, "stack", {
      value: u.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, Te) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const n of this.nodes)
        n.loc && (t += `

` + nn(n.loc));
    else if (this.source && this.locations)
      for (const n of this.locations)
        t += `

` + st(this.source, n);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function xe(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function _(e, t, n) {
  return new Te(`Syntax Error: ${n}`, {
    source: e,
    positions: [t]
  });
}
class rn {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, n, i) {
    this.start = t.start, this.end = n.end, this.startToken = t, this.endToken = n, this.source = i;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class rt {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, n, i, s, r, a) {
    this.kind = t, this.start = n, this.end = i, this.line = s, this.column = r, this.value = a, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const an = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
};
new Set(Object.keys(an));
var x;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(x || (x = {}));
var oe;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(oe || (oe = {}));
var f;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(f || (f = {}));
function on(e) {
  return e === 9 || e === 32;
}
function G(e) {
  return e >= 48 && e <= 57;
}
function at(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function ot(e) {
  return at(e) || e === 95;
}
function cn(e) {
  return at(e) || G(e) || e === 95;
}
function ln(e) {
  var t;
  let n = Number.MAX_SAFE_INTEGER, i = null, s = -1;
  for (let a = 0; a < e.length; ++a) {
    var r;
    const o = e[a], l = un(o);
    l !== o.length && (i = (r = i) !== null && r !== void 0 ? r : a, s = a, a !== 0 && l < n && (n = l));
  }
  return e.map((a, o) => o === 0 ? a : a.slice(n)).slice(
    (t = i) !== null && t !== void 0 ? t : 0,
    s + 1
  );
}
function un(e) {
  let t = 0;
  for (; t < e.length && on(e.charCodeAt(t)); )
    ++t;
  return t;
}
var c;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(c || (c = {}));
class dn {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const n = new rt(c.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = n, this.token = n, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== c.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const n = fn(this, t.end);
          t.next = n, n.prev = t, t = n;
        }
      while (t.kind === c.COMMENT);
    return t;
  }
}
function hn(e) {
  return e === c.BANG || e === c.DOLLAR || e === c.AMP || e === c.PAREN_L || e === c.PAREN_R || e === c.SPREAD || e === c.COLON || e === c.EQUALS || e === c.AT || e === c.BRACKET_L || e === c.BRACKET_R || e === c.BRACE_L || e === c.PIPE || e === c.BRACE_R;
}
function B(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function q(e, t) {
  return ct(e.charCodeAt(t)) && lt(e.charCodeAt(t + 1));
}
function ct(e) {
  return e >= 55296 && e <= 56319;
}
function lt(e) {
  return e >= 56320 && e <= 57343;
}
function v(e, t) {
  const n = e.source.body.codePointAt(t);
  if (n === void 0)
    return c.EOF;
  if (n >= 32 && n <= 126) {
    const i = String.fromCodePoint(n);
    return i === '"' ? `'"'` : `"${i}"`;
  }
  return "U+" + n.toString(16).toUpperCase().padStart(4, "0");
}
function I(e, t, n, i, s) {
  const r = e.line, a = 1 + n - e.lineStart;
  return new rt(t, n, i, r, a, s);
}
function fn(e, t) {
  const n = e.source.body, i = n.length;
  let s = t;
  for (; s < i; ) {
    const r = n.charCodeAt(s);
    switch (r) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++s;
        continue;
      case 10:
        ++s, ++e.line, e.lineStart = s;
        continue;
      case 13:
        n.charCodeAt(s + 1) === 10 ? s += 2 : ++s, ++e.line, e.lineStart = s;
        continue;
      case 35:
        return En(e, s);
      case 33:
        return I(e, c.BANG, s, s + 1);
      case 36:
        return I(e, c.DOLLAR, s, s + 1);
      case 38:
        return I(e, c.AMP, s, s + 1);
      case 40:
        return I(e, c.PAREN_L, s, s + 1);
      case 41:
        return I(e, c.PAREN_R, s, s + 1);
      case 46:
        if (n.charCodeAt(s + 1) === 46 && n.charCodeAt(s + 2) === 46)
          return I(e, c.SPREAD, s, s + 3);
        break;
      case 58:
        return I(e, c.COLON, s, s + 1);
      case 61:
        return I(e, c.EQUALS, s, s + 1);
      case 64:
        return I(e, c.AT, s, s + 1);
      case 91:
        return I(e, c.BRACKET_L, s, s + 1);
      case 93:
        return I(e, c.BRACKET_R, s, s + 1);
      case 123:
        return I(e, c.BRACE_L, s, s + 1);
      case 124:
        return I(e, c.PIPE, s, s + 1);
      case 125:
        return I(e, c.BRACE_R, s, s + 1);
      case 34:
        return n.charCodeAt(s + 1) === 34 && n.charCodeAt(s + 2) === 34 ? _n(e, s) : Tn(e, s);
    }
    if (G(r) || r === 45)
      return pn(e, s, r);
    if (ot(r))
      return mn(e, s);
    throw _(
      e.source,
      s,
      r === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : B(r) || q(n, s) ? `Unexpected character: ${v(e, s)}.` : `Invalid character: ${v(e, s)}.`
    );
  }
  return I(e, c.EOF, i, i);
}
function En(e, t) {
  const n = e.source.body, i = n.length;
  let s = t + 1;
  for (; s < i; ) {
    const r = n.charCodeAt(s);
    if (r === 10 || r === 13)
      break;
    if (B(r))
      ++s;
    else if (q(n, s))
      s += 2;
    else
      break;
  }
  return I(
    e,
    c.COMMENT,
    t,
    s,
    n.slice(t + 1, s)
  );
}
function pn(e, t, n) {
  const i = e.source.body;
  let s = t, r = n, a = !1;
  if (r === 45 && (r = i.charCodeAt(++s)), r === 48) {
    if (r = i.charCodeAt(++s), G(r))
      throw _(
        e.source,
        s,
        `Invalid number, unexpected digit after 0: ${v(
          e,
          s
        )}.`
      );
  } else
    s = ne(e, s, r), r = i.charCodeAt(s);
  if (r === 46 && (a = !0, r = i.charCodeAt(++s), s = ne(e, s, r), r = i.charCodeAt(s)), (r === 69 || r === 101) && (a = !0, r = i.charCodeAt(++s), (r === 43 || r === 45) && (r = i.charCodeAt(++s)), s = ne(e, s, r), r = i.charCodeAt(s)), r === 46 || ot(r))
    throw _(
      e.source,
      s,
      `Invalid number, expected digit but got: ${v(
        e,
        s
      )}.`
    );
  return I(
    e,
    a ? c.FLOAT : c.INT,
    t,
    s,
    i.slice(t, s)
  );
}
function ne(e, t, n) {
  if (!G(n))
    throw _(
      e.source,
      t,
      `Invalid number, expected digit but got: ${v(
        e,
        t
      )}.`
    );
  const i = e.source.body;
  let s = t + 1;
  for (; G(i.charCodeAt(s)); )
    ++s;
  return s;
}
function Tn(e, t) {
  const n = e.source.body, i = n.length;
  let s = t + 1, r = s, a = "";
  for (; s < i; ) {
    const o = n.charCodeAt(s);
    if (o === 34)
      return a += n.slice(r, s), I(e, c.STRING, t, s + 1, a);
    if (o === 92) {
      a += n.slice(r, s);
      const l = n.charCodeAt(s + 1) === 117 ? n.charCodeAt(s + 2) === 123 ? Nn(e, s) : yn(e, s) : In(e, s);
      a += l.value, s += l.size, r = s;
      continue;
    }
    if (o === 10 || o === 13)
      break;
    if (B(o))
      ++s;
    else if (q(n, s))
      s += 2;
    else
      throw _(
        e.source,
        s,
        `Invalid character within String: ${v(
          e,
          s
        )}.`
      );
  }
  throw _(e.source, s, "Unterminated string.");
}
function Nn(e, t) {
  const n = e.source.body;
  let i = 0, s = 3;
  for (; s < 12; ) {
    const r = n.charCodeAt(t + s++);
    if (r === 125) {
      if (s < 5 || !B(i))
        break;
      return {
        value: String.fromCodePoint(i),
        size: s
      };
    }
    if (i = i << 4 | F(r), i < 0)
      break;
  }
  throw _(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${n.slice(
      t,
      t + s
    )}".`
  );
}
function yn(e, t) {
  const n = e.source.body, i = ke(n, t + 2);
  if (B(i))
    return {
      value: String.fromCodePoint(i),
      size: 6
    };
  if (ct(i) && n.charCodeAt(t + 6) === 92 && n.charCodeAt(t + 7) === 117) {
    const s = ke(n, t + 8);
    if (lt(s))
      return {
        value: String.fromCodePoint(i, s),
        size: 12
      };
  }
  throw _(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${n.slice(t, t + 6)}".`
  );
}
function ke(e, t) {
  return F(e.charCodeAt(t)) << 12 | F(e.charCodeAt(t + 1)) << 8 | F(e.charCodeAt(t + 2)) << 4 | F(e.charCodeAt(t + 3));
}
function F(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function In(e, t) {
  const n = e.source.body;
  switch (n.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw _(
    e.source,
    t,
    `Invalid character escape sequence: "${n.slice(
      t,
      t + 2
    )}".`
  );
}
function _n(e, t) {
  const n = e.source.body, i = n.length;
  let s = e.lineStart, r = t + 3, a = r, o = "";
  const l = [];
  for (; r < i; ) {
    const d = n.charCodeAt(r);
    if (d === 34 && n.charCodeAt(r + 1) === 34 && n.charCodeAt(r + 2) === 34) {
      o += n.slice(a, r), l.push(o);
      const u = I(
        e,
        c.BLOCK_STRING,
        t,
        r + 3,
        // Return a string of the lines joined with U+000A.
        ln(l).join(`
`)
      );
      return e.line += l.length - 1, e.lineStart = s, u;
    }
    if (d === 92 && n.charCodeAt(r + 1) === 34 && n.charCodeAt(r + 2) === 34 && n.charCodeAt(r + 3) === 34) {
      o += n.slice(a, r), a = r + 1, r += 4;
      continue;
    }
    if (d === 10 || d === 13) {
      o += n.slice(a, r), l.push(o), d === 13 && n.charCodeAt(r + 1) === 10 ? r += 2 : ++r, o = "", a = r, s = r;
      continue;
    }
    if (B(d))
      ++r;
    else if (q(n, r))
      r += 2;
    else
      throw _(
        e.source,
        r,
        `Invalid character within String: ${v(
          e,
          r
        )}.`
      );
  }
  throw _(e.source, r, "Unterminated string.");
}
function mn(e, t) {
  const n = e.source.body, i = n.length;
  let s = t + 1;
  for (; s < i; ) {
    const r = n.charCodeAt(s);
    if (cn(r))
      ++s;
    else
      break;
  }
  return I(
    e,
    c.NAME,
    t,
    s,
    n.slice(t, s)
  );
}
const On = 10, ut = 2;
function dt(e) {
  return W(e, []);
}
function W(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return Sn(e, t);
    default:
      return String(e);
  }
}
function Sn(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const n = [...t, e];
  if (Dn(e)) {
    const i = e.toJSON();
    if (i !== e)
      return typeof i == "string" ? i : W(i, n);
  } else if (Array.isArray(e))
    return An(e, n);
  return gn(e, n);
}
function Dn(e) {
  return typeof e.toJSON == "function";
}
function gn(e, t) {
  const n = Object.entries(e);
  return n.length === 0 ? "{}" : t.length > ut ? "[" + Ln(e) + "]" : "{ " + n.map(
    ([s, r]) => s + ": " + W(r, t)
  ).join(", ") + " }";
}
function An(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > ut)
    return "[Array]";
  const n = Math.min(On, e.length), i = e.length - n, s = [];
  for (let r = 0; r < n; ++r)
    s.push(W(e[r], t));
  return i === 1 ? s.push("... 1 more item") : i > 1 && s.push(`... ${i} more items`), "[" + s.join(", ") + "]";
}
function Ln(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const n = e.constructor.name;
    if (typeof n == "string" && n !== "")
      return n;
  }
  return t;
}
const Cn = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function(t, n) {
    return t instanceof n;
  } : function(t, n) {
    if (t instanceof n)
      return !0;
    if (typeof t == "object" && t !== null) {
      var i;
      const s = n.prototype[Symbol.toStringTag], r = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in t ? t[Symbol.toStringTag] : (i = t.constructor) === null || i === void 0 ? void 0 : i.name
      );
      if (s === r) {
        const a = dt(t);
        throw new Error(`Cannot use ${s} "${a}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class ht {
  constructor(t, n = "GraphQL request", i = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || te(!1, `Body must be a string. Received: ${dt(t)}.`), this.body = t, this.name = n, this.locationOffset = i, this.locationOffset.line > 0 || te(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || te(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function bn(e) {
  return Cn(e, ht);
}
function vn(e, t) {
  return new Rn(e, t).parseDocument();
}
class Rn {
  constructor(t, n = {}) {
    const i = bn(t) ? t : new ht(t);
    this._lexer = new dn(i), this._options = n, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const t = this.expectToken(c.NAME);
    return this.node(t, {
      kind: f.NAME,
      value: t.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: f.DOCUMENT,
      definitions: this.many(
        c.SOF,
        this.parseDefinition,
        c.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(c.BRACE_L))
      return this.parseOperationDefinition();
    const t = this.peekDescription(), n = t ? this._lexer.lookahead() : this._lexer.token;
    if (n.kind === c.NAME) {
      switch (n.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (t)
        throw _(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (n.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(n);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const t = this._lexer.token;
    if (this.peek(c.BRACE_L))
      return this.node(t, {
        kind: f.OPERATION_DEFINITION,
        operation: x.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const n = this.parseOperationType();
    let i;
    return this.peek(c.NAME) && (i = this.parseName()), this.node(t, {
      kind: f.OPERATION_DEFINITION,
      operation: n,
      name: i,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const t = this.expectToken(c.NAME);
    switch (t.value) {
      case "query":
        return x.QUERY;
      case "mutation":
        return x.MUTATION;
      case "subscription":
        return x.SUBSCRIPTION;
    }
    throw this.unexpected(t);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      c.PAREN_L,
      this.parseVariableDefinition,
      c.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: f.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(c.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(c.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const t = this._lexer.token;
    return this.expectToken(c.DOLLAR), this.node(t, {
      kind: f.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: f.SELECTION_SET,
      selections: this.many(
        c.BRACE_L,
        this.parseSelection,
        c.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(c.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const t = this._lexer.token, n = this.parseName();
    let i, s;
    return this.expectOptionalToken(c.COLON) ? (i = n, s = this.parseName()) : s = n, this.node(t, {
      kind: f.FIELD,
      alias: i,
      name: s,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(c.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(t) {
    const n = t ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(c.PAREN_L, n, c.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(t = !1) {
    const n = this._lexer.token, i = this.parseName();
    return this.expectToken(c.COLON), this.node(n, {
      kind: f.ARGUMENT,
      name: i,
      value: this.parseValueLiteral(t)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const t = this._lexer.token;
    this.expectToken(c.SPREAD);
    const n = this.expectOptionalKeyword("on");
    return !n && this.peek(c.NAME) ? this.node(t, {
      kind: f.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(t, {
      kind: f.INLINE_FRAGMENT,
      typeCondition: n ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const t = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
      kind: f.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(t, {
      kind: f.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(t) {
    const n = this._lexer.token;
    switch (n.kind) {
      case c.BRACKET_L:
        return this.parseList(t);
      case c.BRACE_L:
        return this.parseObject(t);
      case c.INT:
        return this.advanceLexer(), this.node(n, {
          kind: f.INT,
          value: n.value
        });
      case c.FLOAT:
        return this.advanceLexer(), this.node(n, {
          kind: f.FLOAT,
          value: n.value
        });
      case c.STRING:
      case c.BLOCK_STRING:
        return this.parseStringLiteral();
      case c.NAME:
        switch (this.advanceLexer(), n.value) {
          case "true":
            return this.node(n, {
              kind: f.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(n, {
              kind: f.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(n, {
              kind: f.NULL
            });
          default:
            return this.node(n, {
              kind: f.ENUM,
              value: n.value
            });
        }
      case c.DOLLAR:
        if (t)
          if (this.expectToken(c.DOLLAR), this._lexer.token.kind === c.NAME) {
            const i = this._lexer.token.value;
            throw _(
              this._lexer.source,
              n.start,
              `Unexpected variable "$${i}" in constant value.`
            );
          } else
            throw this.unexpected(n);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const t = this._lexer.token;
    return this.advanceLexer(), this.node(t, {
      kind: f.STRING,
      value: t.value,
      block: t.kind === c.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(t) {
    const n = () => this.parseValueLiteral(t);
    return this.node(this._lexer.token, {
      kind: f.LIST,
      values: this.any(c.BRACKET_L, n, c.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(t) {
    const n = () => this.parseObjectField(t);
    return this.node(this._lexer.token, {
      kind: f.OBJECT,
      fields: this.any(c.BRACE_L, n, c.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(t) {
    const n = this._lexer.token, i = this.parseName();
    return this.expectToken(c.COLON), this.node(n, {
      kind: f.OBJECT_FIELD,
      name: i,
      value: this.parseValueLiteral(t)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(t) {
    const n = [];
    for (; this.peek(c.AT); )
      n.push(this.parseDirective(t));
    return n;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(t) {
    const n = this._lexer.token;
    return this.expectToken(c.AT), this.node(n, {
      kind: f.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(t)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const t = this._lexer.token;
    let n;
    if (this.expectOptionalToken(c.BRACKET_L)) {
      const i = this.parseTypeReference();
      this.expectToken(c.BRACKET_R), n = this.node(t, {
        kind: f.LIST_TYPE,
        type: i
      });
    } else
      n = this.parseNamedType();
    return this.expectOptionalToken(c.BANG) ? this.node(t, {
      kind: f.NON_NULL_TYPE,
      type: n
    }) : n;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: f.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(c.STRING) || this.peek(c.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("schema");
    const i = this.parseConstDirectives(), s = this.many(
      c.BRACE_L,
      this.parseOperationTypeDefinition,
      c.BRACE_R
    );
    return this.node(t, {
      kind: f.SCHEMA_DEFINITION,
      description: n,
      directives: i,
      operationTypes: s
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const t = this._lexer.token, n = this.parseOperationType();
    this.expectToken(c.COLON);
    const i = this.parseNamedType();
    return this.node(t, {
      kind: f.OPERATION_TYPE_DEFINITION,
      operation: n,
      type: i
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("scalar");
    const i = this.parseName(), s = this.parseConstDirectives();
    return this.node(t, {
      kind: f.SCALAR_TYPE_DEFINITION,
      description: n,
      name: i,
      directives: s
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("type");
    const i = this.parseName(), s = this.parseImplementsInterfaces(), r = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(t, {
      kind: f.OBJECT_TYPE_DEFINITION,
      description: n,
      name: i,
      interfaces: s,
      directives: r,
      fields: a
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(c.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      c.BRACE_L,
      this.parseFieldDefinition,
      c.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const t = this._lexer.token, n = this.parseDescription(), i = this.parseName(), s = this.parseArgumentDefs();
    this.expectToken(c.COLON);
    const r = this.parseTypeReference(), a = this.parseConstDirectives();
    return this.node(t, {
      kind: f.FIELD_DEFINITION,
      description: n,
      name: i,
      arguments: s,
      type: r,
      directives: a
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      c.PAREN_L,
      this.parseInputValueDef,
      c.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const t = this._lexer.token, n = this.parseDescription(), i = this.parseName();
    this.expectToken(c.COLON);
    const s = this.parseTypeReference();
    let r;
    this.expectOptionalToken(c.EQUALS) && (r = this.parseConstValueLiteral());
    const a = this.parseConstDirectives();
    return this.node(t, {
      kind: f.INPUT_VALUE_DEFINITION,
      description: n,
      name: i,
      type: s,
      defaultValue: r,
      directives: a
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("interface");
    const i = this.parseName(), s = this.parseImplementsInterfaces(), r = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(t, {
      kind: f.INTERFACE_TYPE_DEFINITION,
      description: n,
      name: i,
      interfaces: s,
      directives: r,
      fields: a
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("union");
    const i = this.parseName(), s = this.parseConstDirectives(), r = this.parseUnionMemberTypes();
    return this.node(t, {
      kind: f.UNION_TYPE_DEFINITION,
      description: n,
      name: i,
      directives: s,
      types: r
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(c.EQUALS) ? this.delimitedMany(c.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("enum");
    const i = this.parseName(), s = this.parseConstDirectives(), r = this.parseEnumValuesDefinition();
    return this.node(t, {
      kind: f.ENUM_TYPE_DEFINITION,
      description: n,
      name: i,
      directives: s,
      values: r
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      c.BRACE_L,
      this.parseEnumValueDefinition,
      c.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const t = this._lexer.token, n = this.parseDescription(), i = this.parseEnumValueName(), s = this.parseConstDirectives();
    return this.node(t, {
      kind: f.ENUM_VALUE_DEFINITION,
      description: n,
      name: i,
      directives: s
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw _(
        this._lexer.source,
        this._lexer.token.start,
        `${j(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("input");
    const i = this.parseName(), s = this.parseConstDirectives(), r = this.parseInputFieldsDefinition();
    return this.node(t, {
      kind: f.INPUT_OBJECT_TYPE_DEFINITION,
      description: n,
      name: i,
      directives: s,
      fields: r
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      c.BRACE_L,
      this.parseInputValueDef,
      c.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const t = this._lexer.lookahead();
    if (t.kind === c.NAME)
      switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(t);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const n = this.parseConstDirectives(), i = this.optionalMany(
      c.BRACE_L,
      this.parseOperationTypeDefinition,
      c.BRACE_R
    );
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: f.SCHEMA_EXTENSION,
      directives: n,
      operationTypes: i
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const n = this.parseName(), i = this.parseConstDirectives();
    if (i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: f.SCALAR_TYPE_EXTENSION,
      name: n,
      directives: i
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), s = this.parseConstDirectives(), r = this.parseFieldsDefinition();
    if (i.length === 0 && s.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: f.OBJECT_TYPE_EXTENSION,
      name: n,
      interfaces: i,
      directives: s,
      fields: r
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), s = this.parseConstDirectives(), r = this.parseFieldsDefinition();
    if (i.length === 0 && s.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: f.INTERFACE_TYPE_EXTENSION,
      name: n,
      interfaces: i,
      directives: s,
      fields: r
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const n = this.parseName(), i = this.parseConstDirectives(), s = this.parseUnionMemberTypes();
    if (i.length === 0 && s.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: f.UNION_TYPE_EXTENSION,
      name: n,
      directives: i,
      types: s
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const n = this.parseName(), i = this.parseConstDirectives(), s = this.parseEnumValuesDefinition();
    if (i.length === 0 && s.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: f.ENUM_TYPE_EXTENSION,
      name: n,
      directives: i,
      values: s
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const n = this.parseName(), i = this.parseConstDirectives(), s = this.parseInputFieldsDefinition();
    if (i.length === 0 && s.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: f.INPUT_OBJECT_TYPE_EXTENSION,
      name: n,
      directives: i,
      fields: s
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(c.AT);
    const i = this.parseName(), s = this.parseArgumentDefs(), r = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const a = this.parseDirectiveLocations();
    return this.node(t, {
      kind: f.DIRECTIVE_DEFINITION,
      description: n,
      name: i,
      arguments: s,
      repeatable: r,
      locations: a
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(c.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const t = this._lexer.token, n = this.parseName();
    if (Object.prototype.hasOwnProperty.call(oe, n.value))
      return n;
    throw this.unexpected(t);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(t, n) {
    return this._options.noLocation !== !0 && (n.loc = new rn(
      t,
      this._lexer.lastToken,
      this._lexer.source
    )), n;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(t) {
    return this._lexer.token.kind === t;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(t) {
    const n = this._lexer.token;
    if (n.kind === t)
      return this.advanceLexer(), n;
    throw _(
      this._lexer.source,
      n.start,
      `Expected ${ft(t)}, found ${j(n)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(t) {
    return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(t) {
    const n = this._lexer.token;
    if (n.kind === c.NAME && n.value === t)
      this.advanceLexer();
    else
      throw _(
        this._lexer.source,
        n.start,
        `Expected "${t}", found ${j(n)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(t) {
    const n = this._lexer.token;
    return n.kind === c.NAME && n.value === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(t) {
    const n = t ?? this._lexer.token;
    return _(
      this._lexer.source,
      n.start,
      `Unexpected ${j(n)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(t, n, i) {
    this.expectToken(t);
    const s = [];
    for (; !this.expectOptionalToken(i); )
      s.push(n.call(this));
    return s;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(t, n, i) {
    if (this.expectOptionalToken(t)) {
      const s = [];
      do
        s.push(n.call(this));
      while (!this.expectOptionalToken(i));
      return s;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(t, n, i) {
    this.expectToken(t);
    const s = [];
    do
      s.push(n.call(this));
    while (!this.expectOptionalToken(i));
    return s;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(t, n) {
    this.expectOptionalToken(t);
    const i = [];
    do
      i.push(n.call(this));
    while (this.expectOptionalToken(t));
    return i;
  }
  advanceLexer() {
    const { maxTokens: t } = this._options, n = this._lexer.advance();
    if (t !== void 0 && n.kind !== c.EOF && (++this._tokenCounter, this._tokenCounter > t))
      throw _(
        this._lexer.source,
        n.start,
        `Document contains more that ${t} tokens. Parsing aborted.`
      );
  }
}
function j(e) {
  const t = e.value;
  return ft(e.kind) + (t != null ? ` "${t}"` : "");
}
function ft(e) {
  return hn(e) ? `"${e}"` : e;
}
var Y = /* @__PURE__ */ new Map(), ce = /* @__PURE__ */ new Map(), Et = !0, z = !1;
function pt(e) {
  return e.replace(/[\s,]+/g, " ").trim();
}
function xn(e) {
  return pt(e.source.body.substring(e.start, e.end));
}
function kn(e) {
  var t = /* @__PURE__ */ new Set(), n = [];
  return e.definitions.forEach(function(i) {
    if (i.kind === "FragmentDefinition") {
      var s = i.name.value, r = xn(i.loc), a = ce.get(s);
      a && !a.has(r) ? Et && console.warn("Warning: fragment with name " + s + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : a || ce.set(s, a = /* @__PURE__ */ new Set()), a.add(r), t.has(r) || (t.add(r), n.push(i));
    } else
      n.push(i);
  }), Q(Q({}, e), { definitions: n });
}
function wn(e) {
  var t = new Set(e.definitions);
  t.forEach(function(i) {
    i.loc && delete i.loc, Object.keys(i).forEach(function(s) {
      var r = i[s];
      r && typeof r == "object" && t.add(r);
    });
  });
  var n = e.loc;
  return n && (delete n.startToken, delete n.endToken), e;
}
function Bn(e) {
  var t = pt(e);
  if (!Y.has(t)) {
    var n = vn(e, {
      experimentalFragmentVariables: z,
      allowLegacyFragmentVariables: z
    });
    if (!n || n.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    Y.set(t, wn(kn(n)));
  }
  return Y.get(t);
}
function k(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  typeof e == "string" && (e = [e]);
  var i = e[0];
  return t.forEach(function(s, r) {
    s && s.kind === "Document" ? i += s.loc.source.body : i += s, i += e[r + 1];
  }), Bn(i);
}
function Mn() {
  Y.clear(), ce.clear();
}
function Un() {
  Et = !1;
}
function Fn() {
  z = !0;
}
function Pn() {
  z = !1;
}
var U = {
  gql: k,
  resetCaches: Mn,
  disableFragmentWarnings: Un,
  enableExperimentalFragmentVariables: Fn,
  disableExperimentalFragmentVariables: Pn
};
(function(e) {
  e.gql = U.gql, e.resetCaches = U.resetCaches, e.disableFragmentWarnings = U.disableFragmentWarnings, e.enableExperimentalFragmentVariables = U.enableExperimentalFragmentVariables, e.disableExperimentalFragmentVariables = U.disableExperimentalFragmentVariables;
})(k || (k = {}));
k.default = k;
const Gn = k;
function le(e, t) {
  if (t === 0)
    return y.error(
      "Max depth for validation of subscription data is reached, please provide your data in the correct format."
    ), { isGQL: !1, sysId: null, isREST: !1 };
  if (Array.isArray(e)) {
    for (const n of e) {
      const i = le(n, t - 1);
      if (Object.values(i).includes(!0))
        return i;
    }
    return { isGQL: !1, sysId: null, isREST: !1 };
  } else {
    const n = Object.hasOwn(e, "__typename"), i = Object.hasOwn(e, "sys") ? e.sys.id : null, s = Object.hasOwn(e, "fields");
    return n || i || s ? { isGQL: n, sysId: i, isREST: s } : le(Object.values(e), t - 1);
  }
}
function Vn(e, t) {
  const n = { ...e };
  if (n.query) {
    if (typeof n.query == "string")
      try {
        n.query = Gn(n.query);
      } catch {
        y.error(
          "The provided GraphQL query is invalid, please provide it in the correct format.",
          e
        ), n.query = void 0;
      }
    t && (y.warn(
      "The query param is ignored as it can only be used together with GraphQL.",
      e
    ), n.query = void 0);
  }
  return n;
}
function Kn(e) {
  const { isGQL: t, isREST: n, sysId: i } = le(e.data, 10), s = Vn(e, n);
  return i ? !t && !n ? (y.error(
    'For live updates as a basic requirement the provided data must include the "fields" property for REST or "__typename" for Graphql, otherwise the data will be treated as invalid and live updates are not applied.',
    s.data
  ), {
    isValid: !1,
    sysId: i,
    isGQL: t,
    isREST: n,
    config: s
  }) : {
    isGQL: t,
    isREST: n,
    sysId: i,
    isValid: !0,
    config: s
  } : (y.error(
    'Live Updates requires the "sys.id" to be present on the provided data',
    s.data
  ), {
    isValid: !1,
    sysId: i,
    isGQL: t,
    isREST: n,
    config: s
  });
}
var A = /* @__PURE__ */ ((e) => (e.CONNECTED = "CONNECTED", e.DISCONNECTED = "DISCONNECTED", e.ERROR = "ERROR", e.IFRAME_CONNECTED = "IFRAME_CONNECTED", e.TAGGED_FIELD_CLICKED = "TAGGED_FIELD_CLICKED", e.URL_CHANGED = "URL_CHANGED", e.SUBSCRIBED = "SUBSCRIBED", e.ENTRY_UPDATED = "ENTRY_UPDATED", e.ENTRY_SAVED = "ENTRY_SAVED", e.DEBUG_MODE_ENABLED = "DEBUG_MODE_ENABLED", e.ENTITY_NOT_KNOWN = "ENTITY_NOT_KNOWN", e.UNKNOWN_REFERENCE_LOADED = "UNKNOWN_REFERENCE_LOADED", e))(A || {});
function jn(e, t, n, i) {
  S(
    "TAGGED_FIELD_CLICKED",
    {
      action: "TAGGED_FIELD_CLICKED",
      fieldId: e,
      entryId: t,
      locale: n
    },
    i
  );
}
function Yn(e, t, n, i) {
  S(
    "TAGGED_FIELD_CLICKED",
    {
      action: "TAGGED_FIELD_CLICKED",
      fieldId: e,
      assetId: t,
      locale: n
    },
    i
  );
}
function Hn(e, t) {
  return e.name === "Asset" ? t.id : t.apiName || t.name;
}
async function Ne(e, t, n, i, s, r, a) {
  let o;
  const l = "urn" in t.sys ? t.sys.urn : t.sys.id;
  if (r.has(l))
    y.warn("Detected a circular reference, stopping recursion"), o = r.get(l);
  else {
    const { reference: u } = await fe({
      entityReferenceMap: i,
      referenceId: t.sys.id,
      ...Qe(t) ? { isAsset: !0 } : void 0,
      locale: n,
      sendMessage: a
    });
    o = u, r.set(l, u);
  }
  if (!o)
    return e;
  const d = de(o);
  for (const u in o.fields) {
    const h = o.fields[u];
    if (Ce(h) && s < H)
      await Nt(
        d,
        o,
        n,
        u,
        i,
        s + 1,
        r,
        a
      );
    else if (Array.isArray(h) && Ce(h[0]) && s < H)
      await Tt(
        d,
        o,
        n,
        u,
        i,
        s + 1,
        r,
        a
      );
    else if (Ee(h))
      await It(
        d,
        o,
        u,
        n,
        i,
        s + 1,
        r,
        a
      );
    else {
      if (be(h) || Array.isArray(h) && be(h[0]))
        return y.warn("Detected a resource link, support is still under development."), d;
      ue({
        dataFromPreviewApp: d.fields,
        updateFromEntryEditor: o,
        name: u
      });
    }
  }
  return d;
}
async function Tt(e, t, n, i, s, r, a, o) {
  var l;
  if (!((l = t.fields) != null && l[i])) {
    delete e.fields[i];
    return;
  }
  return e.fields[i] = await Promise.all(
    t.fields[i].map(
      (d, u) => {
        var h;
        return Ne(
          (h = e.fields[i]) == null ? void 0 : h[u],
          d,
          n,
          s,
          r + 1,
          a,
          o
        );
      }
    )
  ).then((d) => d.filter(Boolean)), e;
}
async function Nt(e, t, n, i, s, r, a, o) {
  var d;
  const l = (d = t == null ? void 0 : t.fields) == null ? void 0 : d[i];
  if (!l) {
    delete e.fields[i];
    return;
  }
  return e.fields[i] = await Ne(
    e.fields[i],
    l,
    n,
    s,
    r + 1,
    a,
    o
  ), e;
}
async function yt(e, t, n, i, s, r) {
  var a;
  if ($e.includes(e.nodeType) && e.data && e.data.target && e.data.target.sys && (e.data.target.sys.linkType === "Entry" || e.data.target.sys.linkType === "Asset")) {
    const l = {
      sys: { id: ((a = e.data.target) == null ? void 0 : a.sys.id) || "", type: "Link", linkType: e.data.target.sys.linkType }
    };
    e.data.target = await Ne(
      void 0,
      l,
      n,
      t,
      i + 1,
      s,
      r
    );
  }
  if (e.content)
    for (const o of e.content)
      await yt(
        o,
        t,
        n,
        i + 1,
        s,
        r
      );
}
async function It(e, t, n, i, s, r, a, o) {
  var d;
  const l = (d = t.fields) == null ? void 0 : d[n];
  if (!t.fields[n]) {
    delete e.fields[n];
    return;
  }
  if (Ee(l)) {
    e.fields[n] = l;
    for (const u of l.content)
      await yt(
        u,
        s,
        i,
        r,
        a,
        o
      );
  }
}
async function $n(e, t, n, i, s, r, a, o) {
  var l;
  if (t.sys.id !== n.sys.id)
    return t;
  for (const d of e.fields) {
    const u = Hn(e, d);
    if (Ue(d) || d.type === "File")
      ue({
        dataFromPreviewApp: t.fields,
        updateFromEntryEditor: n,
        name: u
      });
    else if (d.type === "Link" && r < H)
      await Nt(
        t,
        n,
        i,
        u,
        s,
        r + 1,
        a,
        o
      );
    else if (d.type === "Array" && ((l = d.items) == null ? void 0 : l.type) === "Link" && r < H)
      await Tt(
        t,
        n,
        i,
        u,
        s,
        r + 1,
        a,
        o
      );
    else if (d.type === "RichText")
      await It(
        t,
        n,
        u,
        i,
        s,
        r,
        a,
        o
      );
    else if (d.type === "ResourceLink")
      return y.warn("Detected a resource link, support is still under development."), t;
  }
  return t;
}
class Qn {
  constructor({ locale: t, targetOrigin: n }) {
    p(this, "subscriptions", /* @__PURE__ */ new Map());
    p(this, "storage");
    p(this, "defaultLocale");
    p(this, "sendMessage");
    this.defaultLocale = t, this.sendMessage = (i, s) => S(i, s, n), this.storage = new At("live-updates", /* @__PURE__ */ new Map()), window.addEventListener("beforeunload", () => this.clearStorage());
  }
  async mergeEntity({
    contentType: t,
    dataFromPreviewApp: n,
    entityReferenceMap: i,
    locale: s,
    updateFromEntryEditor: r,
    gqlParams: a
  }) {
    return "__typename" in n ? {
      data: await (n.__typename === "Asset" ? qe(n, r, a) : Wt({
        contentType: t,
        dataFromPreviewApp: n,
        updateFromEntryEditor: r,
        locale: s,
        entityReferenceMap: i,
        gqlParams: a,
        sendMessage: this.sendMessage
      })),
      updated: !0
    } : this.isCfEntity(n) ? {
      data: await $n(
        t,
        n,
        r,
        s,
        i,
        0,
        /* @__PURE__ */ new Map(),
        this.sendMessage
      ),
      updated: !0
    } : { updated: !1, data: n };
  }
  /**
   * Merges the `dataFromPreviewApp` together with the `updateFromEntryEditor`
   * If there is not direct match, it will try to merge things together recursively
   * caches the result if cache is enabled and the entity has a `sys.id`.
   * Caching should not be enabled for every entry,
   * because nested references could be merged differently together and this could solve to data loss.
   */
  async mergeNestedReference({ dataFromPreviewApp: t, ...n }, i) {
    const s = K(t) && t.sys.id, r = i && s;
    let a = !1, o = (r ? this.storage.get(s, n.locale) : void 0) || t;
    if (K(o) && s === n.updateFromEntryEditor.sys.id) {
      const l = await this.mergeEntity({ ...n, dataFromPreviewApp: o });
      o = l.data, a = l.updated;
    } else
      for (const l in o)
        if (o[l] && typeof o[l] == "object") {
          const d = await this.merge(
            { ...n, dataFromPreviewApp: o[l] },
            !1
          );
          o[l] = d.data, a = a || d.updated;
        }
    return r && this.storage.set(s, n.locale, o), { data: o, updated: a };
  }
  async merge({ dataFromPreviewApp: t, ...n }, i = !0) {
    if (Array.isArray(t)) {
      const s = [];
      let r = !1;
      for (const a of t) {
        const o = await this.mergeNestedReference(
          { ...n, dataFromPreviewApp: a },
          i
        );
        s.push(o.data), r = r || o.updated;
      }
      return { data: s, updated: r };
    }
    return this.mergeNestedReference({ ...n, dataFromPreviewApp: t }, i);
  }
  isCfEntity(t) {
    return K(t) && "fields" in t;
  }
  /** Receives the data from the message event handler and calls the subscriptions */
  async receiveMessage(t) {
    if ("action" in t && t.action === "ENTRY_UPDATED" || t.method === A.ENTRY_UPDATED) {
      const { entity: n, contentType: i, entityReferenceMap: s } = t;
      await Promise.all(
        [...this.subscriptions].map(async ([, r]) => {
          try {
            const { updated: a, data: o } = await this.merge({
              // Clone the original data on the top level,
              // to prevent cloning multiple times (time)
              // or modifying the original data (failure potential)
              dataFromPreviewApp: de(r.data),
              locale: r.locale || this.defaultLocale,
              updateFromEntryEditor: n,
              contentType: i,
              entityReferenceMap: s,
              gqlParams: r.gqlParams
            });
            a && r.callback(o);
          } catch (a) {
            this.sendErrorMessage({
              message: a.message,
              payload: { data: r.data, update: n },
              type: "SUBSCRIPTION_UPDATE_FAILED"
            }), y.error("Failed to apply live update", {
              error: a,
              subscribedData: r.data,
              updateFromEditor: n
            });
          }
        })
      );
    }
  }
  async restore(t, n, i) {
    if (!t)
      return;
    const s = (o) => {
      if (K(o)) {
        const l = this.storage.get(o.sys.id, n);
        if (l)
          return l;
      }
      return o;
    };
    let r;
    if (Array.isArray(t))
      r = t.map(s);
    else {
      const o = s(t);
      o !== t && (r = o);
    }
    const a = this.subscriptions.get(i);
    a && r && a.callback(r);
  }
  clearStorage() {
    this.storage.clear();
  }
  sendErrorMessage(t) {
    this.sendMessage(A.ERROR, t);
  }
  /**
   * Subscribe to data changes from the Editor, returns a function to unsubscribe
   * Will be called once initially for the restored data
   */
  subscribe(t) {
    const { isGQL: n, isValid: i, sysId: s, isREST: r, config: a } = Kn(t);
    if (!i)
      return this.sendErrorMessage({
        message: "Failed to subscribe",
        payload: { isGQL: n, isValid: i, sysId: s, isREST: r },
        type: "SUBSCRIPTION_SETUP_FAILED"
      }), () => {
      };
    const o = bt(), l = a.locale || this.defaultLocale;
    return this.subscriptions.set(o, {
      ...a,
      sysId: s,
      gqlParams: a.query ? qt(a.query) : void 0
    }), setTimeout(() => {
      this.restore(a.data, l, o);
    }, 0), this.sendMessage(A.SUBSCRIBED, {
      action: A.SUBSCRIBED,
      type: n ? "GQL" : "REST",
      locale: l,
      entryId: s,
      event: "edit"
    }), () => {
      this.subscriptions.delete(o);
    };
  }
}
class zn {
  constructor({ locale: t }) {
    p(this, "locale");
    p(this, "subscription");
    this.locale = t;
  }
  subscribe(t) {
    return this.subscription && y.log(
      "There is already a subscription for the save event, the existing one will be replaced."
    ), this.subscription = t, () => {
      this.subscription = void 0;
    };
  }
  receiveMessage(t) {
    if (t.method === A.ENTRY_SAVED && this.subscription) {
      const { entity: n } = t;
      Ve().includes(n.sys.id) && this.subscription(n);
    }
  }
}
const Zn = Be, Jn = ["https://app.contentful.com", "https://app.eu.contentful.com"], O = class O {
  // Static method to initialize the LivePreview SDK
  static init(t) {
    var o;
    if (typeof t != "object" || !(t != null && t.locale))
      throw new Error(
        "Init function have to be called with a locale configuration (for example: `ContentfulLivePreview.init({ locale: 'en-US'})`)"
      );
    const {
      debugMode: n,
      enableInspectorMode: i,
      enableLiveUpdates: s,
      locale: r,
      targetOrigin: a = Jn
    } = t;
    if (typeof window < "u") {
      if (!Ct())
        return this.liveUpdatesEnabled = !1, Promise.resolve(null);
      if (n && ye(n), typeof i == "boolean" && (this.inspectorModeEnabled = i), typeof s == "boolean" && (this.liveUpdatesEnabled = s), this.locale = r, this.targetOrigin = Array.isArray(a) ? a : [a], this.initialized)
        return y.log("You have already initialized the Live Preview SDK."), Promise.resolve(O.inspectorMode);
      this.inspectorModeEnabled && (this.inspectorMode = new jt({
        locale: r,
        targetOrigin: this.targetOrigin,
        ignoreManuallyTaggedElements: (o = t.experimental) == null ? void 0 : o.ignoreManuallyTaggedElements
      })), this.liveUpdatesEnabled && (this.liveUpdates = new Qn({ locale: r, targetOrigin: this.targetOrigin }), this.saveEvent = new zn({ locale: r })), window.addEventListener("message", (d) => {
        var u, h, E;
        if (wt(d)) {
          if (y.log("Received message", d.data), "action" in d.data && d.data.action === "DEBUG_MODE_ENABLED" || d.data.method === A.DEBUG_MODE_ENABLED) {
            ye(!0);
            return;
          }
          this.inspectorModeEnabled && ((u = this.inspectorMode) == null || u.receiveMessage(d.data)), this.liveUpdatesEnabled && ((h = this.liveUpdates) == null || h.receiveMessage(d.data), (E = this.saveEvent) == null || E.receiveMessage(d.data));
        }
      }), vt(() => {
        S(
          A.URL_CHANGED,
          {
            action: A.URL_CHANGED,
            taggedElementCount: document.querySelectorAll(
              `[${N.ENTRY_ID}]`
            ).length
          },
          this.targetOrigin
        );
      });
      const l = document.querySelectorAll(
        `[${N.ENTRY_ID}]`
      ).length;
      return S(
        A.CONNECTED,
        {
          action: A.CONNECTED,
          connected: !0,
          tags: l,
          taggedElementCount: l,
          locale: this.locale,
          isInspectorEnabled: this.inspectorModeEnabled,
          isLiveUpdatesEnabled: this.liveUpdatesEnabled
        },
        this.targetOrigin
      ), this.initialized = !0, Promise.resolve(O.inspectorMode);
    }
  }
  static subscribe(t, n) {
    if (!this.liveUpdatesEnabled)
      return () => {
      };
    const i = typeof t == "string" ? t : "edit", s = typeof t == "object" ? t : n;
    if (i === "save") {
      if (!this.saveEvent)
        throw new Error(
          "Save event is not initialized, please call `ContentfulLivePreview.init()` first."
        );
      return this.saveEvent.subscribe(s.callback);
    }
    if (!this.liveUpdates)
      throw new Error(
        "Live updates are not initialized, please call `ContentfulLivePreview.init()` first."
      );
    return this.liveUpdates.subscribe(s);
  }
  // Static method to render live preview data-attributes to HTML element output
  static getProps(t) {
    const { fieldId: n, locale: i } = t;
    return this.inspectorModeEnabled ? t.assetId !== void 0 && n ? {
      [N.FIELD_ID]: n,
      [N.ASSET_ID]: t.assetId,
      [N.LOCALE]: i
    } : t.entryId !== void 0 && n ? {
      [N.FIELD_ID]: n,
      [N.ENTRY_ID]: t.entryId,
      [N.LOCALE]: i
    } : (y.warn("Missing property for inspector mode", { ...t }), null) : null;
  }
  static toggleInspectorMode() {
    return this.inspectorModeEnabled = !this.inspectorModeEnabled, this.inspectorModeEnabled;
  }
  static toggleLiveUpdatesMode() {
    return this.liveUpdatesEnabled = !this.liveUpdatesEnabled, this.liveUpdatesEnabled;
  }
  static openEntryInEditor(t) {
    if (t.assetId !== void 0 && t.fieldId) {
      Yn(
        t.fieldId,
        t.assetId,
        t.locale || this.locale,
        this.targetOrigin
      );
      return;
    }
    if (t.entryId !== void 0 && t.fieldId) {
      jn(
        t.fieldId,
        t.entryId,
        t.locale || this.locale,
        this.targetOrigin
      );
      return;
    }
    y.error("Please provide field id and entry id to openEntryInEditor.");
  }
  /**
   * Returns a list of tagged entries on the page
   */
  static getEntryList() {
    return Ve();
  }
};
p(O, "initialized", !1), p(O, "inspectorMode", null), p(O, "liveUpdates", null), p(O, "saveEvent", null), p(O, "inspectorModeEnabled", !0), p(O, "liveUpdatesEnabled", !0), p(O, "locale"), p(O, "sendMessage"), p(O, "targetOrigin");
let we = O;
export {
  we as C,
  C as I,
  Dt as L,
  Ie as P,
  Zn as V,
  gt as a,
  A as b,
  L as c,
  Wn as d,
  Yn as e,
  Xn as g,
  jn as o
};
//# sourceMappingURL=index-Kl1rRWuJ.js.map
